import React, { useState } from 'react';

export default function TestarErroBoundary() {
    const host = (typeof window !== 'undefined' && window.location.hostname) || '';
    const ambientePermitido = host.startsWith('dashboard') || host === 'localhost' || host === '127.0.0.1';

    throw new Error(`Teste manual do ErrorBoundary (${host})`);

}
